import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "axios";
import {
AuthErrors,
ReviewError,
ReviewRequest,
UserEditErrors,
UserEditRequest,
UserResetPasswordRequest,
UserResponse
} from "../../types/types";

import RequestService from "../../utils/request-service";
import { BASE_URL } from "../../constants/urlConstants";
import {
AUTH_EDIT_PASSWORD,
REVIEW,
USERS,
USERS_GRAPHQL
} from "../../constants/urlConstants";

import { userByQuery } from "../../utils/graphql-query/users-query";

/*
---------------------------------------------------
FETCH NORMAL USER (Admin / Customer)
---------------------------------------------------
*/
export const fetchUserInfo = createAsyncThunk<UserResponse>(
"user/fetchUserInfo",
async () => {
    const response = await RequestService.get(USERS, true);
    return response.data;
  }
);

/*
---------------------------------------------------
FETCH DISTRIBUTOR INFO
---------------------------------------------------
*/
export const fetchDistributorInfo = createAsyncThunk<UserResponse, string>(
  "user/fetchDistributorInfo",
  async (distributorId) => {

    const response = await axios.get(
      `${BASE_URL}/api/finalle/${distributorId}`,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    const d = response.data?.[0];

    return {
      id:           d.id,
      email:        d.email,
      firstName:    d.businessName,
      lastName:     "",
      city:         "",
      address:      d.address,
      phoneNumber:  d.mobile,
      postIndex:    d.pincode,
      roles:        ["ROLE_DISTRIBUTOR"],
      provider:     "LOCAL",

      // Distributor-specific fields — make sure UserResponse type includes these
      distributorId:          d.distributorId,
      meEmpId:                d.meEmpId,
      parentType:             d.parentType,
      serviceStatus:          d.serviceStatus,
      todayShopStatus:        d.todayShopStatus,
      shopCloseReason:        d.shopCloseReason,
      shopCloseUntil:         d.shopCloseUntil,
      distributionStartDate:  d.distributionStartDate,
      distributionEndDate:    d.distributionEndDate,
      attachmentPaths:        d.attachmentPaths,
      roleType:               d.roleType,
      deactivatedByAdmin:     d.deactivatedByAdmin,
      firstLogin:             d.firstLogin,
    };
  }
);

/*
---------------------------------------------------
UPDATE USER INFO
---------------------------------------------------
*/
export const updateUserInfo = createAsyncThunk<
  UserResponse,
  UserEditRequest,
  { rejectValue: UserEditErrors }
>("user/updateUserInfo", async (request, thunkApi) => {
  try {
    const response = await RequestService.put(USERS, request, true);
    return response.data;
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.response.data);
  }
});

/*
---------------------------------------------------
UPDATE PASSWORD
---------------------------------------------------
*/
export const updateUserPassword = createAsyncThunk<
  string,
  UserResetPasswordRequest,
  { rejectValue: AuthErrors }
>("user/updateUserPassword", async (request, thunkApi) => {
  try {
    const response = await RequestService.put(AUTH_EDIT_PASSWORD, request, true);
    return response.data;
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.response.data);
  }
});

/*
---------------------------------------------------
ADD REVIEW
---------------------------------------------------
*/
export const addReviewToPerfume = createAsyncThunk<
  {},
  ReviewRequest,
  { rejectValue: ReviewError }
>("user/addReviewToPerfume", async (request, thunkApi) => {
  try {
    return await RequestService.post(REVIEW, request);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error.response.data);
  }
});

/*
---------------------------------------------------
GRAPHQL USER FETCH
---------------------------------------------------
*/
export const fetchUserInfoByQuery = createAsyncThunk<UserResponse, string>(
  "user/fetchUserInfoByQuery",
  async (userId) => {
    const response = await RequestService.post(
      USERS_GRAPHQL,
      { query: userByQuery(userId) },
      true
    );

    return response.data.data.user;
  }
);